// extracted by mini-css-extract-plugin
export default {"form":"BenchmarkQuestionForm_form__+LS8V","buttons":"BenchmarkQuestionForm_buttons__95M1t"};